import { Box, Paper, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import { getPageContent, toPageContentDTO } from '../../../services/page.service';
import { showAxiosMessageError } from '../../../services/error-message.service';
import { PageContentDto } from '../../../services/dtos/page-content.dto';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { PageContentExterneDto } from '../../../services/dtos/page-content-externe.dto';

/**
 * Composant les information de l'entreprise
 * @constructor
 */
export default function EnterpriseInfosUi() {
    const showMessage = useSnackbars();
    //Permet de savoir si on est passé une fois dans l'useEffect
    const dataFetchedRef = useRef(false);
    // Déclaration du loader pour l'affichage du Skeleton
    const [loading, setLoading] = useState<boolean>(true);

    //Création de données par défaut pour la page
    const [pageContent, setPageContent] = useState<any>({
        tel: '',
        nom: '',
    });

    useEffect(() => {
        if (dataFetchedRef.current) {
            return;
        }
        dataFetchedRef.current = true;

        getPageContent('' + 'enterprise-infos')
            .then(async result => {
                //On met le résultat de la request dans la variable envoyée à la page
                if (result) {
                    setPageContent(await toContent(result));
                }
                setLoading(false);
            })
            .catch(error => {
                //Affichage du message d'erreur si la request ne récupère rien
                console.error('Erreur lors de la récupération du contenu de la page');
                showAxiosMessageError(error, showMessage);
            });
    }, []);

    const toContent = async (result: PageContentExterneDto[]): Promise<any> => {
        let data: { [key: string]: string } = {};
        result.forEach(e => {
            data[e.codeChamps?.toLowerCase()] = e.valeur;
        });

        return {
            tel: data['tel'],
            nom: data['nom'],
        };
    };

    // Création de la page
    return (
        <Paper elevation={3} style={{ height: '100%', textAlign: 'center' }}>
            <Box style={{ padding: 20 }}>
                {/*Texte explicatif pour les appels*/}
                <Typography variant="body1" style={{ marginBottom: 5 }}>
                    Vous pouvez nous joindre par téléphone
                </Typography>
                <Typography variant="body1" style={{ fontWeight: 'bold', marginBottom: 5 }}>
                    <PhoneInTalkIcon color="primary" style={{ verticalAlign: 'middle', marginRight: 10 }} />
                    {pageContent.tel}
                </Typography>
                <Typography variant="body1" style={{ marginBottom: 20 }}>
                    du lundi au jeudi de 8H00 à 17h30 et le vendredi de 8H00 à 17H00
                </Typography>
                <Typography variant="body1" style={{ marginBottom: 20 }}>
                    Ou nous écrire
                </Typography>
                {/*Texte explicatif pour l'adresse*/}
                <Typography variant="body1" style={{ fontWeight: 'bold', marginBottom: 5 }}>
                    {pageContent.nom}
                </Typography>
                <Typography variant="body1" style={{ fontWeight: 'bold', marginBottom: 5 }}>
                    Relation aux usagers
                </Typography>
                <Typography variant="body1" style={{ fontWeight: 'bold', marginBottom: 5 }}>
                    Cité Administrative des Vassaules CS 23076 - 10012 TROYES{' '}
                </Typography>
            </Box>
        </Paper>
    );
}
